import React from 'react';
import classnames from 'classnames';
import { Icon } from 'tea-component';

import type { IBaseProps } from '@home/types/common';
import type { IVersionFigure } from '@home/components/VersionPopup/VersionFigure/types';

interface IVersionFigureContentProps extends IBaseProps {
  isFullscreen?: boolean;
  versionFigures?: IVersionFigure[];
}

const navigate2Link = (linto?: string) => {
  if (!linto) return;
  if (['http://', 'https://'].some((protocal) => linto?.startsWith(protocal))) {
    window.open(linto);
  } else {
    const { origin } = location;
    const url = linto?.startsWith('/') ? origin + linto : `${origin}/${linto}`;
    window.open(url);
  }
};

const VersionFigureContent: React.FC<IVersionFigureContentProps> = (props) => {
  const { style, className, isFullscreen = false, versionFigures } = props;

  return (
    <div style={style} className={classnames('dbh-version-figure__content', className)}>
      <ul className="dbh-version-figure__list">
        {versionFigures?.map((versionFigure, versionFigureIdx) => {
          const { title, text, linto, img_url: imgUrls } = versionFigure || {};
          return (
            <li key={versionFigureIdx} className="dbh-version-figure__item">
              {!isFullscreen && (
                <>
                  <h3 className="dbh-version-figure__sub-title">{title}</h3>
                  {text && <p className="dbh-version-figure__desc" dangerouslySetInnerHTML={{ __html: text }}></p>}
                  {linto && (
                    <div className="dbh-version-figure__linkbar">
                      <span
                        className="dbh-version-figure__link"
                        onClick={(e) => {
                          e.stopPropagation();
                          navigate2Link(linto);
                        }}
                      >
                        <Icon className="dbh-version-figure__link-icon" type="externallink" color="#326FF0" />
                        {linto}
                      </span>
                    </div>
                  )}
                </>
              )}
              {imgUrls?.map((imgUrl, imgUrlIdx) => (
                <div key={imgUrlIdx} className="dbh-version-figure__img-list">
                  <img
                    className={classnames('dbh-version-figure__img-item', { clickable: !!linto })}
                    src={imgUrl}
                    alt=""
                    onClick={(e) => {
                      e.stopPropagation();
                      if (!isFullscreen) return;
                      navigate2Link(linto);
                    }}
                  />
                </div>
              ))}
            </li>
          );
        })}
      </ul>
    </div>
  );
};

export default React.memo(VersionFigureContent);
